<template>
  <a :href="'/products/' + product.handle" class="search-result">
    <div class="search-result__image product-thumb">
      <img :src="product.image" alt="product thumbnail" />
    </div>
    <div class="search-result__title">
      {{ product.title }}
      <strong class="dash">&ndash;</strong>
      <strong>{{ product.option2 }}</strong>
    </div>
    <div class="search-result__price">{{ localisePrice(product.price) }}</div>
  </a>
</template>

<script>
export default {
  props: {
    product: { type: Object, required: true },
  },
  methods: {
    localisePrice(formattedPrice) {
      return window.argent ? window.argent.convertFormatted(formattedPrice) : formattedPrice
    },
  },
}
</script>
